import { ClientVarsDomainMapInfo } from './client-vars-domain-map-info';
/**
 * clientVars与领域层的proxy
 */
var ClientVarsProxy = /** @class */ (function () {
    function ClientVarsProxy() {
    }
    ClientVarsProxy.createClientVarsToDomainProxy = function (docMetaDomainService, authDomainService, userInfoDomainService, clientVars) {
        ClientVarsProxy.createLevel2PrivilegeProxy(authDomainService, clientVars);
        ClientVarsProxy.createLevel2AdvPolicyProxy(authDomainService, clientVars);
        ClientVarsProxy.createLevel1Proxy(docMetaDomainService, authDomainService, userInfoDomainService, clientVars);
    };
    ClientVarsProxy.getProxyHandler = function (infoMap) {
        return {
            get: function (target, key) {
                if (Object.keys(infoMap).includes(key)) {
                    return infoMap[key];
                }
                return target[key];
            },
            set: function (target, key, value) {
                if (Object.keys(infoMap).includes(key)) {
                    // eslint-disable-next-line no-param-reassign
                    infoMap[key] = value;
                }
                else {
                    // eslint-disable-next-line no-param-reassign
                    target[key] = value;
                }
                return true;
            },
        };
    };
    ClientVarsProxy.createLevel1Proxy = function (docMetaDomainService, authDomainService, userInfoDomainService, clientVarsObj) {
        var clientVars = clientVarsObj;
        var infoMap = ClientVarsDomainMapInfo.getLevel1MapInfo(docMetaDomainService, authDomainService, userInfoDomainService);
        var handler = ClientVarsProxy.getProxyHandler(infoMap);
        global.clientVars = new Proxy(clientVars, handler);
    };
    ClientVarsProxy.createLevel2PrivilegeProxy = function (authDomainService, clientVarsObj) {
        var clientVars = clientVarsObj;
        var infoMap = ClientVarsDomainMapInfo.getLevel2AdvPolicyMapInfo(authDomainService);
        var privilegeHandler = ClientVarsProxy.getProxyHandler(infoMap);
        clientVars.privilegeAttribute = new Proxy(clientVarsObj.privilegeAttribute || {}, privilegeHandler);
    };
    ClientVarsProxy.createLevel2AdvPolicyProxy = function (authDomainService, clientVarsObj) {
        var clientVars = clientVarsObj;
        var infoMap = ClientVarsDomainMapInfo.getLevel2AdvPolicyMapInfo(authDomainService);
        var advPolicyHandler = ClientVarsProxy.getProxyHandler(infoMap);
        clientVars.advPolicy = new Proxy(clientVars.advPolicy, advPolicyHandler);
    };
    return ClientVarsProxy;
}());
export { ClientVarsProxy };
